import React from "react";
import { IgnoreZone } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

const IMAGE_WIDTH = 333;
const IMAGE_HEIGHT = 187;

export const ActiveIgnoreZonesWindow = ({
  selectedAlertCameraInfo,
  ignoreZonesSelectedAlert,
  loadingIgnoreZonesInfo,
}: {
  selectedAlertCameraInfo: any;
  ignoreZonesSelectedAlert: any;
  loadingIgnoreZonesInfo: boolean;
}) => {
  const pointsCreator = (polygon: number[][]) => {
    return polygon
      .map(([x, y]) => `${x * IMAGE_WIDTH},${y * IMAGE_HEIGHT}`)
      .join(" ");
  };

  return (
    <div className="h-[260px] w-[350px]">
      {selectedAlertCameraInfo.preview_url && ignoreZonesSelectedAlert && (
        <div className="relative w-[333px] h-[187px]">
          <img
            className="w-[333px] h-[187px] block"
            src={selectedAlertCameraInfo.preview_url}
            alt="Camera preview with ignore zones"
          />
          <svg
            className="absolute top-0 left-0 w-[333px] h-[187px] pointer-events-none"
            width={IMAGE_WIDTH}
            height={IMAGE_HEIGHT}
            style={{ overflow: "visible" }}
          >
            {ignoreZonesSelectedAlert.map((object: IgnoreZone) =>
              object.coordinates.map((polygon: number[][], polygonIndex: number) => (
                <polygon
                  key={`${object.label}-${polygonIndex}`}
                  points={pointsCreator(polygon)}
                  stroke={object.line_color}
                  strokeWidth="2"
                  fill={object.line_color}
                  fillOpacity="0.3"
                />
              ))
            )}
          </svg>
          <div className="mt-2 space-y-1">
            {ignoreZonesSelectedAlert.map((object: IgnoreZone) => (
              <div key={object.label} className="flex items-center gap-2">
                <div
                  className="w-3 h-2 shrink-0 rounded-sm"
                  style={{ background: object.line_color }}
                />
                <p className="font-mulish text-[10px] text-actuate-blue">
                  {object.label_display_name}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
      {!loadingIgnoreZonesInfo && !selectedAlertCameraInfo.preview_url && (
        <div>
          <p className="font-mulish text-[12px]">
            Unable to Display Ignore Zones
          </p>
        </div>
      )}
    </div>
  );
};
